import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { DownloadService } from 'src/app/shared/services/download.service';
import { UserService } from 'src/app/shared/services/user.service';
import { WorkerProfileService } from 'src/app/shared/services/worker-profile.service';
import { NavigationStart, Router } from '@angular/router';
import { MatSnackBar,MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NavbarService } from 'src/app/shared/services/navbar.service';
import { IWGSharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-worker-profile',
  templateUrl: './worker-profile.component.html',
  styleUrls: ['./worker-profile.component.scss']
})
export class WorkerProfileComponent implements OnInit {
  @ViewChild("workerProfile1") workerProfile1: NgForm;

  isLoading:boolean = false;
  hasData:boolean = false;
  state = {};
  buttonCss = 'button-hasvalue';
  WokerProfile = null;
  WorkerProfileID = null;
  ResumeFileID:any;
  ResumeFileGUID = null;
  ResumeFileName = null;
  submitted = false;
  WorkerName:any;
  WorkerDisplayName:any;
  workerProfile = {
    profile:null,
    skills:null,
    referenceURL:null
  };
  is_myrate_dirty:boolean;
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  hasWorkerProfile:boolean;

  constructor(private userService: UserService, 
    private download: DownloadService, private workerProfileService:WorkerProfileService,
    public router: Router, private toast:MatSnackBar, private nav: NavbarService, private sharedService: IWGSharedService) {
      this.hasWorkerProfile = this.userService.hasWorkerProfile();

      this.sharedService.HasWorkerProfile.subscribe((data) => { 
        this.hasWorkerProfile = data;
      });

    }

  ngOnInit(): void {
    this.isLoading=true;
    this.nav.show();
    this.nav.setActiveMenu('my-talent');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'my-talent'});

    if (this.userService.getUser() === null) {
      window.location.href = './Login';
    }
  this.WorkerName=this.userService.getLoggedInName();
  this.WorkerDisplayName = this.userService.getWorkerDisplayName();
  this.sharedService.iwgfileuploaded.subscribe((data) => {
    if (data == null) {return; }    
    data = data.Data;
    if (data.TheObject) {
       this.ResumeFileID = data.TheObject.FileDisplayID; //Pass this scope to Save API.
        this.ResumeFileGUID = data.TheObject.ID;
    }
    this.enableSave();   
});
  this.workerProfileService.getWorkerprofileId().pipe(catchError((err) => {
    console.log('There was an error getting data in component', err);
    throw (err);
  })).subscribe(workerDetails => {
    workerDetails = workerDetails.data.Data;
    if (workerDetails && workerDetails != null) {
        this.WokerProfile = workerDetails;
        this.WorkerProfileID = workerDetails.WorkerProfileID;
        this.ResumeFileID = workerDetails.ResumeFileID;
        this.ResumeFileGUID = workerDetails.ResumeFileGUID;
        this.ResumeFileName = workerDetails.ResumeFileName;

        this.workerProfile.profile = workerDetails.Profile;
        this.workerProfile.skills = workerDetails.Skill;
        this.workerProfile.referenceURL = workerDetails.ReferenceURL;
    }
    this.isLoading = false;
    this.enableSave();    
  }); 
  }

  isConfirm() {
    return confirm('Are you sure you want to leave the page without submitting?');
  }

// onStart({}, function ($transition) {           
//   if ($rootScope.is_myrate_dirty === true) {
//       var answer = isConfirm();
//       if (!answer) {
//           // $transition.abort();
//           return false;
//       }
//   }
//   $rootScope.is_myrate_dirty = false;
//   return true;
// });



markIsDirty() {
  var isDirty = false;
  if (this.WokerProfile) {
      if (this.WokerProfile.Profile !== this.workerProfile.profile) {
          isDirty = true;
      }
      if (this.WokerProfile.Skill !== this.workerProfile.skills) {
          isDirty = true;
      }
      if (this.WokerProfile.ReferenceURL !== this.workerProfile.referenceURL) {
          isDirty = true;
      }
      if (this.WokerProfile.ResumeFileGUID !== this.ResumeFileGUID) {
          isDirty = true;
      }
  }
  else {
      isDirty = true;
  }
  this.sharedService.setMyRateDirty(isDirty);
}
preventSubmit(isPrevent) {
  this.submitted = !(isPrevent);
}
deleteFile(){
  this.sharedService.setMyRateDirty(false);
  this.ResumeFileID = null;
  this.ResumeFileGUID = null;
  this.sharedService.iwgfilefiledeleted.next(true);
  this.enableSave();
};
enableSave(){
  if ((this.workerProfile.profile && this.workerProfile.profile.trim() !== '') ||
      (this.workerProfile.skills && this.workerProfile.skills.trim() !== '') ||
      (this.workerProfile.referenceURL && this.workerProfile.referenceURL.trim() !== '')
      || this.ResumeFileID) {
      this.hasData = true;
      this.buttonCss = 'button-hasvalue';
  } else {
      this.hasData = false;
      this.buttonCss = 'button-novalue';
  }
  this.markIsDirty();
}
clear() {
  this.workerProfile.skills = null;
  this.workerProfile.profile = null;
  this.workerProfile.referenceURL = null;
  this.ResumeFileID = null;
  this.ResumeFileGUID = null;
  // $rootScope.$broadcast('iwg.file.file.deleted');
  this.enableSave();
}
downloadResume() {
  this.download.saveAs('/Api/File/' + this.ResumeFileGUID).then(() => {
  });
};

OnClickMyTalent(){
  if (this.sharedService.getMyRateDirty()) {
    if (this.isConfirm()) {
        this.sharedService.setMyRateDirty(false);
        if (this.hasWorkerProfile) {
          this.router.navigate(["/worker-profile-detail"]);
        } else {
          this.router.navigate(["/worker-profile"]);
        }
    }
  } else {
    this.router.navigate(["/worker-profile-detail"]);
  }
}

Update() {
  this.isLoading = true;
  let props = {};
  props= {
      profile: this.workerProfile.profile,
      skill: this.workerProfile.skills,
      reference_url: this.workerProfile.referenceURL,
      resume_file_id: this.ResumeFileID
  }
  if (this.WorkerProfileID) {
    return this.workerProfileService
    .update(this.WorkerProfileID, props).toPromise()
  } else {
    return this.workerProfileService
    .save(props).toPromise()
  }
}
submit = () => {
  if (this.submitted == false) {
      return;
  }
  if (this.workerProfile1.valid == false) {
      return;
  }

  return this.Update().then((response) => {
      this.isLoading = false;
      if (response.data.ErrorCode == 200) {
          response = response.data.Data;
          if (response.workerProfileViewModel) {
              this.WorkerProfileID = response.workerProfileViewModel.WorkerProfileID;
          }
          this.sharedService.setMyRateDirty(false);
          this.sharedService.HasWorkerProfile.next(true);
          this.showConfirmationToast('Thank you for updating your profile in MyTalent.');
          this.router.navigate(["worker-profile-detail"]);
          //ResetDivAndElements();
      } else {         
          alert('Error occured while processing your request.')
      }

  });
};

showConfirmationToast(text){
  this.toast.open(text, "Got it", {
    duration: 2000,horizontalPosition:this.Hposition,
    verticalPosition:this.VPosition,
    panelClass: 'iwg-toast-text-white',
  });
}
}
